var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { DailyLessonChangeReasonView } from './daily_lesson_change_reason_view';
import { DailyLessonChangeLoadingView } from './daily_lesson_change_loading_view';
import { DailyLessonChangeCompleteView } from './daily_lesson_change_complete_view';
export const DailyLessonChangeOverlay = ({ apiClient, courseLessonID, onClickClose, onClickBackToHome, onClickShowProfile, }) => {
    const [view, setView] = React.useState('reason');
    const [reasons, setReasons] = React.useState([]);
    React.useEffect(() => {
        apiClient.fetchDailyLessonChangeReasons().then(setReasons);
    }, [apiClient]);
    const onClickReason = (reason) => __awaiter(void 0, void 0, void 0, function* () {
        if (reason.skipLessonChange) {
            onClickBackToHome();
            return;
        }
        setView('loading');
        yield apiClient.changeDailyLessonLesson({
            courseDaysLessonID: courseLessonID,
            changeReason: reason.changeReason,
        });
        setView('complete');
    });
    if (view === 'complete') {
        return (React.createElement(DailyLessonChangeCompleteView, { onClickBackToHome: onClickBackToHome, onClickShowProfile: onClickShowProfile }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(DailyLessonChangeReasonView, { reasons: reasons, onClickClose: onClickClose, onClickBackToHome: onClickBackToHome, onClickReason: onClickReason }),
        view === 'loading' && React.createElement(DailyLessonChangeLoadingView, null)));
};
